import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { MicromomentTimelineTileComponent } from './micromoment-timeline-tile.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule.withConfig({ useColumnBasisZero: false }), SharedModule ],
  declarations: [MicromomentTimelineTileComponent],
  exports: [MicromomentTimelineTileComponent]
})
export class MicromomentTimelineTileModule {}
